import john from 'images/png/reviews/john.png';
import will from 'images/png/reviews/will.png';
import liz from 'images/png/reviews/elisabeth.png';

const slides = [
  {
    id: 'e342we223e',
    image: john,
    rating: 4,
    name: 'John',
    feedback: 'Ema was good but I had expected more.',
  },
  {
    id: 'e342we224e',
    image: will,
    rating: 5,
    name: 'Will',
    feedback:
      'Last time I have visited a cooking course by Eva I was impressed with the way she explained everything to people. You can be sure you will manage to cook a delicious dish even if it is your first time in the kitchen! Thank you so much for the masterclass! Looking forward to the next one and highly recommend it to everyone!',
  },
  {
    id: 'e342we225e',
    image: liz,
    rating: 5,
    name: 'Elizabeth',
    feedback: 'I am excited.',
  },
];

export { slides };
